export { FormControlLabel, FormControlLabelProps } from './FormControlLabel';
